<template>
    <div class="profile-order-table">
        <orders :orderList="orders" v-if="orders.length > 0"></orders>
        <div class="empty profile-order-empty" v-else style="text-align: center">
            <img src="../../../assets/profile/empty-cart.png" alt="">
            <router-link :to="{name:'FooterShop'}">
                <p>
                    <Button type="text" style="font-size:16px;">{{$t('shopping_card_go_to_shopping')}} <Icon type="chevron-right"></Icon></Button>
                </p>
            </router-link>
        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>
<script>
    import orders from '../Common/Orders.vue'
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                orders: [],
                spinShow: false
            }
        },
        components: {
            orders
        },
        methods: {
            cancel (index) {
                for (let i in this.goods) {
                    if (index === this.goods[i].id) {
                        this.goods.splice(i, 1)
                    }
                }
            }
        },
        created () {
            this.spinShow = true
            let data = {}
            const module = 'index.php/index.php/index/goods/guessyoulike'
            data.sub_time = Signature.timestamp()
            data.lang = this.$i18n.locale
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.sign = Signature.create(module, data.sub_time)
            data.type = 2
            this.$http.get(process.env.BASEURL + module, {
                params: data
            })
            .then(function (resp) {
                if (parseInt(resp.data.code) === 2000) {
                    console.log(resp.data.data)
                    this.orders = resp.data.data.order_list
                    this.spinShow = false
                }
            }.bind(this))
        }
    }

</script>
<style>

</style>



// WEBPACK FOOTER //
// EndOrder.vue?04dadc7e